import React, { useEffect } from 'react'
import styles from "./AnnoucementDetails.module.scss"
import LogoContainer from './LogoContainer'
import dayjs from 'dayjs'
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { combineClasses } from 'utils/utils'
import { privatePut } from 'services/privateRequest';
import { ANNOUNCEMENT } from 'services/apiEndpoints';

const AnnoucementDetails = ({
    data
}) => {
    useEffect(() => {
        const updateCount = async () => {
            await privatePut( ANNOUNCEMENT, `${data._id}/open` , {})
        }
     data?.deliveryOptions?.notification?.sendType === "sent" && updateCount()
    },[])
    return (
        <div className={styles?.annoucementContainer}>
            <div className={styles?.upper}>
                <ul className={styles?.list}>
                    <li className={styles?.key}>Date
                        {
                            data?.deliveryOptions?.notification?.sendType === "scheduled" ?
                                " Scheduled"
                                :
                                " Sent"
                        }
                    </li>
                    <li className={styles?.value}>{
                        data?.deliveryOptions?.notification?.sendType === "scheduled" ?
                            dayjs(data?.deliveryOptions?.notification?.scheduledTime).format('MMMM D, h:mm A [GMT]Z')
                            :
                            dayjs(data?.createdAt).format('MMMM D, h:mm A [GMT]Z')
                    }</li>
                    {
                        data?.recipientIds?.length > 0 &&
                        <>
                            <li className={combineClasses(styles?.key, styles?.recipientWrapper)}>Sent To</li>
                            <li>
                                {
                                    data?.recipientIds?.map((ele, i) => {
                                        return (
                                            <span key={ele._id} className={styles?.value}>{ele?.name || `${ele?.firstName + " " + ele?.lastName}`}{data?.recipientIds?.length - 1 !== i && ", "}</span>
                                        )
                                    })
                                }
                            </li>
                        </>
                    }
                    <li className={styles?.key}>Sent By</li>
                    <li className={styles?.value}>{`${data?.createdBy?.firstName} ${data?.createdBy?.lastName}`}</li>
                </ul>
                <div className={styles?.bottom_logo}>
                    <LogoContainer count={data?.recipientsStatus?.length} type={"RecipientsCount"} />
                    <LogoContainer count={data?.openedCount} type="openCount" />
                    <LogoContainer count={ Math.floor((data?.openedCount / data?.recipientsStatus?.length) * 100) + " %"} />
                </div>
            </div>
            <div className={styles?.bottom}>
                <div className={styles.bottomDetails}>
                    <h2 style={{ wordBreak: "break-word" }}>{data?.title}</h2>
                    <p style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: data?.message?.replace(/\n/g, "<br />") }} />
                </div>
                {
                    data?.media?.length > 0 &&
                    <div className={styles?.mediaWrapper}>
                        {
                            data.media.map((link, i) => {
                                return (
                                    <a className={styles?.mediaCard} key={i} href={link}
                                        target="_blank"
                                        rel="noopener noreferrer" >
                                        <FileOpenIcon />
                                        <span>
                                            {link?.split("/").pop()}
                                        </span>
                                    </a>
                                )
                            })
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default AnnoucementDetails